import React from 'react'

const Loading = () => {
  return (
    <h2 style={{marginTop : "5rem" , display : "flex" , justifyContent : "center"}}>Loading...</h2>
  )
}

export default Loading